import { AxiosPromise } from 'axios';
import { IVisitorTypeFormValues } from '../form';
import { instance } from '../../../../services';

const updateVisitorType = (data: IVisitorTypeFormValues): AxiosPromise => {
  return instance.put(`api/visitorTypes/${data.id}`, data);
};

export default updateVisitorType;
